import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import PermissionsDropdown from '../PermissionsDropdown/PermissionsDropdown'
import SearchUserDropdown from '../SearchUserDropdown/SearchUserDropdown';
import './SettingsModal.css';

const EditGroupModal = ({ handleClose, show, modalInfo, onEdit }) => {
    const [groupID, setGroupID] = useState('')
    const [groupName, setGroupName] = useState('')
    const [groupMembers, setGroupMembers] = useState([])
    const [permissionTypes, setPermissionTypes] = useState('')
    const [modifiedBy, setModifiedBy] = useState('')
    
    useEffect(() => {
        setGroupID(modalInfo.id);
        setGroupName(modalInfo.name);
        setPermissionTypes(modalInfo.permissionIDList)
        setModifiedBy(localStorage.getItem('badgeID'));
    }, [modalInfo])

    const getPermissionID = (permissionIDProp) => {
        setPermissionTypes(permissionIDProp);
    };

    const onSubmit = (e) => {
        e.preventDefault();

        // if (!groupName) {
        //     alert('Please enter a group name');
        // } else if (groupMembers.length === 0) {
        //     alert('Please select at least a member');
        // } else if (permissionTypes.length === 0) {
        //     alert('Please select at least a permission setting');
        // } else {
        //     const userID = groupMembers.map((item) => item.empId).toString();
        //     const userName = groupMembers.map((item) => item.fullname).toString();
        //     const permission = permissionTypes.toString();

        //     onEdit({
        //         groupID,
        //         groupName,
        //         userID,
        //         userName,
        //         permission,
        //         modifiedBy
        //     });
        // }
        
        const userID = groupMembers.map((item) => item.empId).toString();
        const userName = groupMembers.map((item) => item.formalName).toString();
        const permission = permissionTypes.toString();

        if (!groupName) {
            alert('Please enter a group name');
        } else if (!userID || !userName) {
            alert('Please select at least a member');
        } else if (!permission) {
            alert('Please select at least a permission setting');
        } else {
            onEdit({
                groupID,
                groupName,
                userID,
                userName,
                permission,
                modifiedBy
            });
        }
    };

    return (
        <Modal show={show} onHide={handleClose} className='permission-modal'>
            <Modal.Header>
                <Modal.Title style={{marginBottom: '0px'}}>Edit Permission Group</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={onSubmit}>
                    <Form.Group className='mb-3'>
                        <Form.Label>Group Name</Form.Label>
                        <Form.Control
                            type='text'
                            placeholder='Insert your group name here...'
                            style={{ width: '100%' }}
                            value={groupName}
                            onChange={(e) => setGroupName(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className='mb-3'>
                        <Form.Label>Group Members</Form.Label>
                        <SearchUserDropdown 
                            setGroupMembers={setGroupMembers}
                            modalInfo={modalInfo}
                        />
                    </Form.Group>
                    <Form.Group className='mb-3'>
                        <Form.Label>Permission Settings</Form.Label>
                            <PermissionsDropdown 
                                getPermissionID={getPermissionID} 
                                modalInfo={modalInfo}
                            />
                    </Form.Group>
                    <Button as="input" type="submit" value="Submit"/>
                    <Button variant='outline-secondary' onClick={handleClose}>
                        Close
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default EditGroupModal;
